import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import ROUTES from '../../shared/constants/routes';
import { api } from '../../shared/utils/api';

function fmtDate(iso) {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
}

function fmtTime(secs) {
  if (secs == null) return null;
  return `${secs}s`;
}

export default function TopicQuestions({ topicId, mcqStats, module }) {
  const [questions, setQuestions] = useState(null);
  const [topicStats, setTopicStats] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!topicId) return;
    api(`/api/questions/topic/${topicId}`)
      .then(d => {
        setQuestions(d.questions || []);
        setTopicStats(d.stats || null);
      })
      .catch(() => {
        setQuestions([]);
        setTopicStats(null);
      });
  }, [topicId]);

  const totalAvailable = questions ? questions.length : null;
  const totalAttempted = questions ? questions.filter(q => q.attempt_at !== null).length : null;
  const accuracy = topicStats?.accuracy ?? null;
  const accuracyColor = accuracy == null ? 'var(--text-primary)'
    : accuracy < 50 ? 'var(--red)'
    : accuracy < 75 ? 'var(--amber)'
    : 'var(--green)';

  return (
    <div className="tq-section">
      <div className="tq-label">Practice questions</div>

      {questions === null ? (
        <div className="tq-loading">Loading</div>
      ) : totalAvailable === 0 ? (
        <div className="tq-empty">No questions available yet for this topic.</div>
      ) : (
        <div className="tq-summary">
          <div className="tq-summary-meta">
            {totalAvailable} question{totalAvailable !== 1 ? 's' : ''} available
            {' · '}
            {totalAttempted === 0 ? 'Not yet attempted' : `${totalAttempted} attempted`}
          </div>

          {topicStats && topicStats.attempts > 0 && (
            <div className="tq-summary-stats">
              <div className="tq-summary-stat">
                <span className="tq-summary-stat-label">Accuracy</span>
                <span className="tq-summary-stat-value" style={{ color: accuracyColor }}>
                  {accuracy}% ({topicStats.correct}/{topicStats.attempts} correct)
                </span>
              </div>
              {topicStats.avg_response_time_seconds != null && (
                <div className="tq-summary-stat">
                  <span className="tq-summary-stat-label">Avg time</span>
                  <span className="tq-summary-stat-value">{fmtTime(topicStats.avg_response_time_seconds)} per question</span>
                </div>
              )}
              {topicStats.last_attempted && (
                <div className="tq-summary-stat">
                  <span className="tq-summary-stat-label">Last practiced</span>
                  <span className="tq-summary-stat-value">{fmtDate(topicStats.last_attempted)}</span>
                </div>
              )}
            </div>
          )}

          <div className="tq-summary-actions">
            <button
              className="btn-primary tq-practice-btn"
              onClick={() => navigate(`${ROUTES.QUESTIONS}?mode=topic&topic_id=${topicId}`)}
            >
              Practice this topic
            </button>
          </div>
        </div>
      )}

      {/* Law Drills imported data */}
      {mcqStats && (
        <div className="tq-subsection tq-subsection-secondary">
          <div className="tq-sublabel">Law Drills</div>
          <div className="tq-ld-row">
            <span className="tq-ld-score">Score: {mcqStats.accuracy}% ({mcqStats.attempted} question{mcqStats.attempted !== 1 ? 's' : ''})</span>
          </div>
        </div>
      )}

    </div>
  );
}
